module.exports = __webpack_public_path__ + "static/media/twitter_inverted_hover.fb82ed5f.svg";